import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=022a4d77&scoped=true&"
import script from "./StudentsTable.vue?vue&type=script&lang=ts&"
export * from "./StudentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&id=022a4d77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a4d77",
  null
  
)

export default component.exports